module.exports = __webpack_public_path__ + "static/img/3.75ff694.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/sp/3.png
// module id = 7GJA
// module chunks = 0